
































































import { PropType } from 'vue';
import { User } from './models.ts';

import CoCard from '../co-card/CoCard.vue';
import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoThumbnail from '../co-thumbnail/CoThumbnail.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';
import CoMatch from '../co-match/CoMatch.vue';
import CoUser from '../co-user/CoUser.vue';

export default {
    name: 'CoCardMember',
    components: {
        CoCard,
        CoThumbnail,
        CoButton,
        CoText,
        CoSkeleton,
        CoMatch,
        CoUser,
    },
    props: {
        member: {
            type: Object as PropType<User>,
            required: false,
            default: () => ({} as User),
        },
        hideMessageBtn: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        showMatch: {
            type: Boolean,
            // Parent views pass this flag so instance cards can honor source-space matching settings.
            default: true,
        },
        currentUser: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            followedByUser: false,
        };
    },
    computed: {
        memberScore() {
            // Some member lists use the API field name while compact card models use lower camel case.
            const score = this.member.score !== undefined ? this.member.score : this.member.Score;

            return typeof score === 'number' ? score : null;
        },
        isCurrentUser() {
            return String(this.member?.id || '') === String(this.$store?.state?.me?.ID || '');
        },
        showMemberMatch() {
            return this.showMatch && !this.isCurrentUser && this.memberScore !== null && this.memberScore >= 0;
        },
    },
    methods: {
        randomPercents(from = 0, to = 100) {
            const percents = Math.floor(Math.random() * (to - from + 1) + from);
            return `${percents}%`;
        },
        view() {
            this.$router.push(`/profile/${this.member.slug}`);
        },
        message() {
            // emit event to parent
            this.$emit('message', this.member);
        },
        coUserFromMember() {
            // CoCardMember receives a compact card model; CoUser expects the app user display fields.
            return {
                ID: this.member.id,
                Name: this.member.name,
                ImageURL: this.member.image,
                Slug: this.member.slug,
                Bio: this.member.headline,
            };
        },
        unfollow() {
            // emit event to parent
            // this.$emit('unfollow', this.page);
        },
    },
};
